import React from "react";
import PageErrorMessage from "../common/PageErrorMessage";
import PropTypes from "prop-types";

const ErrorMessage = ({ title, onReload }) => (
  <div className="my-nodes-page">
    <section className="main-content">
      <h1 className="text-center text-uppercase page-title">{title}</h1>;
      <div className="container">
        <div className="text-center">
          <PageErrorMessage onReload={onReload} />
        </div>
      </div>
    </section>
  </div>
);

ErrorMessage.propTypes = {
  title: PropTypes.string.isRequired,
  onReload: PropTypes.func.isRequired
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/incidents/errorMessage.js